'use client';
var classes = {"indicator":"m_717d7ff6","icon":"m_3e4da632","indicator--outline":"m_2980836c"};

export { classes as default };
//# sourceMappingURL=RadioIndicator.module.css.mjs.map
